import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import selection from './selectionFichiersStore'
import grid from './gridStore'
import user from './userStore'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
    key: 'itl-selection',
    storage: window.localStorage,
    modules: ['selection', 'user']
})

export default new Vuex.Store({
    state: {
        searchFile: {
            status: false
        },
        searchSite: {
            status: false
        },
        tools: {
            status: false
        }
    },
    getters: {
        searchFileIsOpen(state) {
            return state.searchFile.status
        },
        searchSiteIsOpen(state) {
            return state.searchSite.status
        },
        toolsIsOpen(state) {
            return state.tools.status
        }
    },
    mutations: {
        setSearchFileStatus (state, status) {
            state.searchFile.status = status
        },
        setSearchSiteStatus (state, status) {
            state.searchSite.status = status
        },
        setToolsStatus (state, status) {
            state.tools.status = status
        }
    },
    actions: {
        openSearchFile ({ commit }) {
            commit('setSearchFileStatus', true)
        },
        closeSearchFile ({ commit }) {
            commit('setSearchFileStatus', false)
        },
        openSearchSite ({ commit }) {
            commit('setSearchSiteStatus', true)
        },
        closeSearchSite ({ commit }) {
            commit('setSearchSiteStatus', false)
        },
        openTools ({ commit }) {
            commit('setToolsStatus', true)
        },
        closeTools ({ commit }) {
            commit('setToolsStatus', false)
        }
    },
    modules: {
        selection,
        user,
        grid
    },
    plugins: [vuexPersist.plugin]
})
